module.exports = __webpack_public_path__ + "static/media/cam.06da8def.svg";